// constants/media.ts

/**
 * Media base URL for constructing full URLs from relative paths
 * Set via VITE_MEDIA_BASE_URL environment variable.
 */
const apiUrl = import.meta.env.VITE_API_URL as string | undefined;
const inferredBaseUrl = apiUrl
  ? apiUrl.replace(/\/api$/, '')
  : (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:4000');

export const MEDIA_BASE_URL = import.meta.env.VITE_MEDIA_BASE_URL || inferredBaseUrl;

/**
 * Build full media URL from relative path
 * @param relativePath - Path like "/uploads/posts/filename.jpg" or "posts/filename.jpg"
 * @returns Full URL like "https://klyx.space/uploads/posts/filename.jpg"
 */
export function getMediaUrl(relativePath: string | null | undefined): string | null {
  if (!relativePath) return null;

  // If path already starts with http:// or https://, return as-is (backwards compatibility)
  if (relativePath.startsWith('http://') || relativePath.startsWith('https://')) {
    return relativePath;
  }

  // Ensure path starts with /
  const normalizedPath = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;

  return `${MEDIA_BASE_URL}${normalizedPath}`;
}
